module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Light.14d6bf77.woff";